import React, { useRef } from 'react';
import { CarouselPortraitProgress, ResponsiveImage } from '@/components';
import { ImageModel } from '@/types';
import Flicking from '@egjs/react-flicking';
import classNames from 'classnames';

type ImageCarouselPortraitModel = {
  images: ImageModel[];
};

const ImageCarouselPortrait = ({ images }: ImageCarouselPortraitModel) => {
  const carousel = useRef<Flicking>(null);
  const [holding, setHolding] = React.useState(false);

  return (
    <div className="w-full pt-8 lg:pt-16">
      <Flicking
        className={classNames(holding ? 'cursor-grabbing' : 'cursor-grab')}
        ref={carousel}
        preventClickOnDrag
        preventDefaultOnDrag
        align="center"
        circularFallback="bound"
        circular
        interruptable
        onHoldStart={() => setHolding(true)}
        onHoldEnd={() => setHolding(false)}
      >
        {images.map((image, index) => (
          <div
            key={index}
            className="h-[250px] w-[162px] px-3 sm:h-[364px] sm:w-[243px] md:h-[456px] md:w-[304px] lg:h-[449px] lg:w-[296px] xl:h-[632px] xl:w-[421px]"
          >
            <ResponsiveImage
              image={image}
              widths={{ xs: 366, sm: 366, md: 366, lg: 366, xl: 366 }}
              heights={{ xs: 549, sm: 549, md: 449, lg: 449, xl: 549 }}
            />
          </div>
        ))}
      </Flicking>
      <div className="relative container mt-12">
        <CarouselPortraitProgress carousel={carousel} className="justify-between !gap-16" />
      </div>
    </div>
  );
};

export default ImageCarouselPortrait;
